import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/freight/air',
}).lazy(() => import('./air.lazy').then((d) => d.Route))
